import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import Pagination from '../../helpers/Pagination';

const $= window.$;

class Sent extends Component {
	constructor(props) {
		super(props);
        this.state={
           sent_mail : [], 
           count : 0,
           pageOfItems:[],
           idd : '',
           searchtext:'',
           datas:[],
        };
        this.onChangePage = this.onChangePage.bind(this);
        this.viewItem = this.viewItem.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getSearch = this.getSearch.bind(this);
        this.onSort = this.onSort.bind(this);
        
	}

    componentWillReceiveProps(nextProps) {
    	this.getSent();
	}

	viewItem(edit_id){
		let old_id = this.state.idd;
		if(edit_id == old_id){
			// alert('same');
			if($("#"+edit_id).css('display')=='none'){
				$("#"+edit_id).show();	
			}
			else{

				$("#"+edit_id).hide();
			}
			this.setState({
				idd : edit_id,
			})
		}
		else{
			$("#"+old_id).hide();
			$("#"+edit_id).show();
			this.setState({
				idd : edit_id,
			})
		}
	}

	handleChange(e){
    	this.setState({
    		[e.target.name] : e.target.value
    	})
    }

    _handleKeyPress(e) {
		if (e.key === "Enter") {
			this.getSearch('search');
		}
	}

    getSearch(){
    	let queryText = this.state.searchtext;
    	var queryResult=[];
        this.state.datas.forEach(function(person){
            if(person.to_address.toString().toLowerCase().indexOf(queryText)!=-1){

            	queryResult.push(person);
            }
        	else if(person.subject.toString().toLowerCase().indexOf(queryText)!=-1){

        		queryResult.push(person);
        	}
        	let total = queryResult.length;
	        this.setState({
	       		sent_mail : queryResult, 
	       		count : total,	
	        })
        }.bind(this));
    }

    onSort(event, sortKey){
	 	// alert('im in');
	    const pageOfItems = this.state.pageOfItems;
	    pageOfItems.sort((a,b) => a[sortKey].localeCompare(b[sortKey]))
	    this.setState({pageOfItems})
	  }

	getSent(){
		let searchtext = '';
		let learnerID = Common.getUserData("id", true);
		// if(type == "search"){
		// 	 searchtext = this.state.searchtext;
		// }
		// else if(type == "reset"){
		// 	searchtext = '';
		// }
	 // 	let corporateID = Common.getUserData("corporateID", true);
		// let productID = Common.getUserData("productID", true);
		let admin_role = Common.getUserData("role", true);

    	fetch(Config.domainUrl+'messages-site/get-sent', {
	        method: 'POST',
	        headers: {
	          'Accept': 'application/json',
	          'Content-Type': 'application/json',
			  'Authorization':'Bearer ' +Common.getTokenData()
	        },

	          body: JSON.stringify({
	            learner_id:learnerID,admin_role:admin_role
	          })
	        }).then((response) => response.json())
	       .then((responseJson) => {
	       	//alert(JSON.stringify(responseJson.sent_mail));
	       	if(responseJson.status != 0){
	       		let total_message = responseJson.sent_mail.length;
	            this.setState({
	            	datas:responseJson.sent_mail,
	            	sent_mail:responseJson.sent_mail,
	            	count : total_message,
	            	pageOfItems:responseJson.sent_mail,
	            	searchtext:searchtext,
	            });
	       		
	       	}

   		 });
	}
   

    componentDidMount() {
    	setTimeout(() => {
    		this.getSent();
		}, 100);
    }

    onChangePage(pageOfItems) {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
        $('#'+this.state.idd).hide();
    }



		render() {

			let rows = this.state.pageOfItems.map((mail,i) => {
				let msg_id = mail.msg_user_id_pk;
				let edit = 'view_edit_sent'+msg_id;
				let attach = mail.attached_files.map((att,k)=>{

					let  file_sent = Config.domainUrl+att.fullpath;
					let new_file = new Buffer(file_sent).toString("base64");
					return(
							<div key={`att_${k}`} className="msg-cont"><a href={`${Config.domainUrl}download/admin/${new_file}`}>{att.filename}</a></div>	
						)
				})
                return (
                		<tbody key={`mailsent_${i}`}>
		                   <tr  id={'msgid'+msg_id}>
			                   	<td><span dangerouslySetInnerHTML={{__html:mail.attachment}}/></td>
				                <td><a href='javascript:void(0);' onClick={(e)=>this.viewItem(edit)}>{mail.to_address}</a></td>
				                <td><a href='javascript:void(0);' onClick={(e)=>this.viewItem(edit)}>{mail.subject}</a></td>
				                <td>{mail.created_date+' IST'}</td>
		                   </tr>
		                   <tr id={'view_edit_sent'+msg_id} style={{display:'none'}}>
		                   		<td colSpan="4" className="view-msg1">
									<div id={"view_send_item"+msg_id} >
										<div className="msg-deatil-cont " id="Detailview">
											<div className="msg-deatil-cont-head " id="viewline" >
						   						<ul>
						                        <li>
						                            <div className="msg-label">From</div>
						                            <div className="msg-cont">{mail.to_address}</div>
						                        </li>
						                        <li>
						                            <div className="msg-label">Date</div>
						                            <div className="msg-cont">{mail.created_date+' IST'}</div>
						                        </li>
						                        <li>
						                            <div className="msg-label">To</div>
						                            <div className="msg-cont">{mail.to_address}</div>
						                        </li>
						                       <li>
													<div className="msg-label">Subject</div>
													<div className="msg-cont">{mail.subject}</div>
												</li>
												{(!mail.attached_files.length)?"":
												<li>
													<div className="msg-label">Attachment</div>
													{attach}
												</li>
												}
						                      </ul>
						       				  <div className="msg-detail-inner">
						       				  	<span dangerouslySetInnerHTML={{__html:mail.content}}/>
						                      </div>
											</div>
						 					</div>
									</div>
								</td>
		                   </tr> 
		                 </tbody>
		                )
		       });

			 (rows.length == 0) ? rows = <tbody><tr align="center"><td colSpan="5">No Sent Mails.</td></tr></tbody> : rows = rows;
			
			return (
				<div >
					<h2>Messages - Sent</h2>
						<div className="message-chart">
              				<div className="message-option">
                				<div className="searchmsg">
									<input type="text" name="searchtext" value={this.state.searchtext} onChange={(e)=>this.handleChange(e)} onKeyPress={(e)=>this._handleKeyPress(e)}/>&nbsp;&nbsp;
									<input type="button" name="submit" value="Search" title="Search" onClick={()=>this.getSearch('search')}/>&nbsp;&nbsp;
									<a href="javascript:void(0);" onClick={()=>this.getSent()} className="button-cancel">Reset</a>
                				</div>
								<div className="check-box2">
				                	<span>{"Total "+this.state.count+" messages"}</span>
						        </div>                                  
							</div>
							<div className="tab-content table-cont6" style={{width:"100%"}}>
								<table width="100%" cellSpacing="0" cellPadding="0" border="0" className="myjourney-table message-table search-table">
									<thead>
										<tr>
											<th style={{width:'20px'}}><img title="Attachment" src={process.env.PUBLIC_URL+"/images/attachment-white.png"}/></th>
											<th onClick={(e)=>this.onSort(e, 'to_address')}><a className="mailsort" href="javascript:void(0);">To &nbsp;<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} border="0" align="absmiddle" /></a></th>
											<th>Subject</th>
											<th onClick={(e)=>this.onSort(e, 'created_date')}><a className="mailsort" href="javascript:void(0);">Sent Date &nbsp;<img src={process.env.PUBLIC_URL+"/images/sort-arrow.png"} border="0" align="absmiddle" /></a></th>
										</tr>
									</thead>
									{rows}
								</table>
								<div className="pull-right">
								<Pagination items={this.state.sent_mail} onChangePage={e=>this.onChangePage(e)} />
								</div>
							</div>
						</div>
				</div>
			);
		}
}

export default Sent;



// WEBPACK FOOTER //
// ./src/personal_interactions/messages/Sent.js